import { callGetApiToServer } from "../callApi";

export async function getEnv() {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    let endUrl = "v1/getCorsEnv";

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
